module.exports = __webpack_public_path__ + "static/img/product-swipe17.d069b5fa.png";